import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { FertilizationCereals } from '../../components/chemistry/Fertilizationofwintercereals(October-December)';



const FertilizationCerealspage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Подкормка озимых зерновых (октябрь-декабрь)</title>
            </Helmet>
            <FertilizationCereals />
        </>
    );
};

export default FertilizationCerealspage
